
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Servidor from "../config/Servidor";
import "./Login.css";

export default function Login() {
  const [usuario, setUsuario] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [mostrarPass, setMostrarPass] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(`${Servidor.IP}/loginsuper`, {
        usuario,
        contrasena,
      });

      if (res.data.ok) {
        const user = res.data.user;

        // Seguridad adicional en el cliente
        const rolesPermitidos = [1, 2, 4];

        if (!rolesPermitidos.includes(Number(user.id_rol))) {
          setError(
            " "
          );
          return;
        }

        localStorage.setItem(
          "user",
          JSON.stringify(user)
        );

        if (Number(user.id_rol) === 1) {
          navigate("/ingresoadmin");
        } else {
          navigate("/ingreso");
        }
      }
    } catch (err) {
      console.error("Error en login:", err);

      if (err.response?.status === 403) {
        setError(
          err.response.data?.msg ||
          " "
        );
      } else if (err.response?.status === 401) {
        setError("Usuario o contraseña incorrectos");
      } else {
        setError("Usuario o contraseña incorrectos");
      }
    }
  };

  return (
    <div className="login-fondo">

      {/* =========================================
          FONDO TECNOLÓGICO
      ========================================= */}

      <div className="circuitos">

        {/* Circuitos */}
        <span className="circuito circuito-1"></span>
        <span className="circuito circuito-2"></span>
        <span className="circuito circuito-3"></span>
        <span className="circuito circuito-4"></span>
        <span className="circuito circuito-5"></span>
        <span className="circuito circuito-6"></span>
        <span className="circuito circuito-7"></span>
        <span className="circuito circuito-8"></span>

        {/* Líneas */}
        <span className="linea linea-1"></span>
        <span className="linea linea-2"></span>
        <span className="linea linea-3"></span>
        <span className="linea linea-4"></span>

        {/* Nodos */}
        <span className="nodo nodo-1"></span>
        <span className="nodo nodo-2"></span>
        <span className="nodo nodo-3"></span>
        <span className="nodo nodo-4"></span>
        <span className="nodo nodo-5"></span>
        <span className="nodo nodo-6"></span>
        <span className="nodo nodo-7"></span>
        <span className="nodo nodo-8"></span>

      </div>

      {/* Cuadrícula tecnológica */}
      <div className="grid-fondo"></div>

      {/* =========================================
          LOGIN
      ========================================= */}

      <form
        className="login-card"
        onSubmit={handleLogin}
      >

        <div className="login-icon">
          🔐
        </div>

        <h2>Inicia Sesión</h2>

        <p className="login-subtitulo">
          Ingresa tus datos para continuar
        </p>

        {/* USUARIO */}

        <div className="campo">

          <label>Usuario</label>

          <div className="input-container">

            <span className="input-icon">
              👤
            </span>

            <input
              type="text"
              placeholder="Escribe tu usuario"
              value={usuario}
              onChange={(e) =>
                setUsuario(e.target.value)
              }
            />

          </div>

        </div>

        {/* CONTRASEÑA */}

        <div className="campo">

          <label>Contraseña</label>

          <div className="input-container">

            <span className="input-icon">
              🔒
            </span>

            <input
              type={
                mostrarPass
                  ? "text"
                  : "password"
              }
              placeholder="Escribe tu contraseña"
              value={contrasena}
              onChange={(e) =>
                setContrasena(e.target.value)
              }
            />

            <button
              type="button"
              className="ojo"
              onClick={() =>
                setMostrarPass(!mostrarPass)
              }
            >
              {mostrarPass ? "🙈" : "👁️"}
            </button>

          </div>

        </div>

        {/* ERROR */}

       

        {/* BOTÓN */}

        <button
          className="login-boton"
          type="submit"
        >
          Ingresar
          <span className="flecha">
            →
          </span>
        </button>

        <div className="login-footer">
          Sistema de administración
        </div>

      </form>

    </div>
  );
}

